import { useMemo } from 'react';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import { bookingBillMapper } from '@/features/dashboard/bookingChanges/types/BookingBill.mapper.ts';
import { ClientBillVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';

/**
 * Ekran osoby zapisującej (B1/B2). Bez kwot — zapisujący nie ma własnego
 * rachunku, a cały zestaw kontaktowy jest jedną pozycją paczki.
 */
const useClientBillView = (bookingId: string | undefined) => {
  const billQuery = useBookingBill(bookingId);
  const draftQuery = useGetOpenDraft(bookingId);

  const view: ClientBillVm | null = useMemo(() => {
    if (!billQuery.data) {
      return null;
    }
    return bookingBillMapper.toClientView(
      billQuery.data,
      draftQuery.data?.items ?? [],
    );
  }, [billQuery.data, draftQuery.data]);

  return {
    view,
    isLoading: billQuery.isLoading || draftQuery.isLoading,
    isError: billQuery.isError || draftQuery.isError,
  };
};

export default useClientBillView;
